import React, { useState, useEffect, useRef } from "react";
import "./Game1.css";
import { Button, Modal } from 'antd';
import { DashboardOutlined } from "@ant-design/icons";

export default function Game1() {
  const [boxPosition, setBoxPosition] = useState({ top: 50, left: 50 });
  const [score, setScore] = useState(0);
  const [time, setTime] = useState(0);
  const [isGameStarted, setIsGameStarted] = useState(false);
  const [isGameOver, setIsGameOver] = useState(false);
  const [boxVisible, setBoxVisible] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const boxRef = useRef(null);
  const timeoutRef = useRef(null);
  const noClickTimeoutRef = useRef(null); // Add a new ref for the no-click timeout

  useEffect(() => {
    let timer;
    if (isGameStarted) {
      timer = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isGameStarted]);

  useEffect(() => {
    if (isGameStarted && !isGameOver) {
      timeoutRef.current = setTimeout(() => {
        setIsGameOver(true);
        setIsGameStarted(false);
        setIsModalOpen(true); // Show the modal when the game is over
      }, 2000); // Set timeout for 2 seconds
    }
    return () => clearTimeout(timeoutRef.current);
  }, [boxVisible, isGameStarted, isGameOver]);

  useEffect(() => {
    if (isGameStarted && !isGameOver) {
      noClickTimeoutRef.current = setTimeout(() => {
        setIsGameOver(true);
        setIsGameStarted(false);
        setIsModalOpen(true); // Show the modal when the game is over
      }, 5000); // Set timeout for 5 seconds without clicking
    }
    return () => clearTimeout(noClickTimeoutRef.current);
  }, [isGameStarted, isGameOver, score]); // Reset the timeout on score change (box click)

  const handleClick = (event) => {
    if (event.target.className === "Game-Box") {
      moveBox();
    } else if (isGameStarted) {
      setIsGameOver(true);
      setIsGameStarted(false);
      setIsModalOpen(true); // Show the modal when the game is over
    }
  };

  const moveBox = () => {
    if (!isGameStarted) {
      setIsGameStarted(true);
    }
    const newTop = Math.floor(Math.random() * 90); // random position between 0 and 90%
    const newLeft = Math.floor(Math.random() * 90); // random position between 0 and 90%
    setBoxPosition({ top: newTop, left: newLeft });
    setScore(score + 1);
    setBoxVisible(true);
    clearTimeout(timeoutRef.current); // Clear any previous timeout
    clearTimeout(noClickTimeoutRef.current); // Clear the no-click timeout
  };

  // const handleRestart = () => {
  //   setIsGameStarted(false);
  //   setIsGameOver(false);
  //   setBoxVisible(true);
  //   setBoxPosition({ top: 50, left: 50 });
  //   setScore(0);
  //   setTime(0);
  //   setIsModalOpen(false);
  // };

  const handleRestart = () => {
    setBoxPosition({ top: 50, left: 50 });
    // setScore(0);
    // setTime(0);
    setIsGameOver(false);
    setIsModalOpen(false);
    setIsGameStarted(true);  // Start the game immediately
    moveBox();  // Move the box to start the game
  };
  

  const handleClose = () => {
    setIsModalOpen(false);
    setIsGameStarted(false);
    setIsGameOver(false);
    setBoxVisible(true);
    setBoxPosition({ top: 50, left: 50 });
    setScore(0);
    setTime(0);
  };

  return (
    <div className="Game-Body" onClick={handleClick}>
      {isGameOver ? (
        <Modal
          title="Game Over"
          visible={isModalOpen}
          onOk={handleClose}
          onCancel={handleClose}
          footer={[
            <Button key="restart" type="primary" onClick={handleRestart}>
              Continue
            </Button>,
            <Button key="close" onClick={handleClose}>
              Restart
            </Button>,
          ]}
        >
          <p>Final Score: {score}</p>
          <p>Final Time: {time}s</p>
        </Modal>
      ) : (
        <>
          <div className="Game1-div">
            <div style={{ display: "flex" }}>
              <p className="Game1-Text2">Score:</p>
              <p className="Game1-Text3">{score}</p>
            </div>

            <p className="Game1-Text1">ClickMover</p>

            <div style={{ display: "flex" }}>
              <DashboardOutlined className="Game1-Text2" />
              <p className="Game1-Text3">{time}s</p>
            </div>
          </div>
          {boxVisible && (
            <div
              className="Game-Box"
              style={{
                top: `${boxPosition.top}%`,
                left: `${boxPosition.left}%`,
              }}
              ref={boxRef}
            ></div>
          )}
        </>
      )}
    </div>
  );
}
